import React, {Component} from 'react';

import IntroNumbers from './IntroNumbers';
import TestNumbers from './TestNumbers';
import TrialNumbers from './TrialNumbers';
import TrialWords from './TrialWords';
import IntroWords from './IntroWords';
import TestWords from './TestWords';
import Pause from 'components/Pause';
import strings from 'strings';
import {TYPES} from '../../constants/index';

const subStages = [
	IntroNumbers,
	TrialNumbers,
	Pause,
	TestNumbers,
	Pause,
	IntroWords,
	TestWords,
	Pause,
];
const subStagesOlderVersion = [
	IntroNumbers,
	TrialNumbers,
	Pause,
	TestNumbers,
	Pause,
	IntroWords,
	TrialWords,
	Pause,
	TestWords,
	Pause,
];
class WorkingMemoryWords extends Component {
	constructor(props) {
		super(props);

		this.state = {
			currentStage: 0,
			currentStep: 0,
		};
	}

	componentWillReceiveProps(newProps) {
		const newState = {};
		let flag = false;
		if (newProps.currentStep !== this.props.currentStep) {
			newState.currentStep = newProps.currentStep;
			flag = true;
		}
		if (newProps.currentStage !== this.props.currentStage) {
			newState.currentStage = newProps.currentStage;
			flag = true;
		}
		if (flag) {
			this.setState(newState);
		}
	}

	render() {
		const {currentStage} = this.state;
		const {ageGroup, testKeyType} = this.props;
		const isNormingTest =
			ageGroup >= 2 ||
			testKeyType === TYPES.ADULT_FOLLOWUP ||
			testKeyType === TYPES.YOUTH_FOLLOWUP;
		const CurrentSubStage = isNormingTest
			? subStages[currentStage]
			: subStagesOlderVersion[currentStage];
		return (
			<div className="WorkingMemory">
				<h2 className="lit-page-title">{strings.ws_testname}</h2>
				<CurrentSubStage
					currentStep={this.state.currentStep}
					nextStep={this.props.nextStep}
					setReady={this.props.setReady}
					startTimer={this.props.startTimer}
					endTimer={this.props.endTimer}
					stepData={this.props.stepData}
					ageGroup={this.props.ageGroup}
					testKeyType={this.props.testKeyType}
				/>
			</div>
		);
	}
}

export default WorkingMemoryWords;
